export default __webpack_public_path__ + "ac6b3d0.png";